import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Gestion_avisos.css';

const GestionAvisos = () => {
  const [saldoActual, setSaldoActual] = useState(0);
  const [tabActivo, setTabActivo] = useState('todos');
  const [avisos, setAvisos] = useState([]);
  const [imgErrors, setImgErrors] = useState({});
  const [showPopupVencimiento, setShowPopupVencimiento] = useState(false);
  const [avisosProxVencer, setAvisosProxVencer] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    cargarDatos();
  }, []);

const cargarDatos = async () => {
    try {
      // GET saldo disponible
      const responseSaldo = await fetch(
        `${process.env.REACT_APP_SALDO_DEV_URL}/get_consultasaldo.php`,
        { method: 'GET', credentials: 'include' }
      );
      const dataSaldo = await responseSaldo.json();
      if (dataSaldo.success) {
        setSaldoActual(dataSaldo.saldo_actual);
      }

      // GET avisos del usuario
      const responseAvisos = await fetch(
        `${process.env.REACT_APP_GESTION_AVISOS_URL}/get_avisos.php`,
        { method: 'GET', credentials: 'include' }
      );
      const dataAvisos = await responseAvisos.json();
      if (dataAvisos.success) {
        const avisosData = dataAvisos.data;

        // GET renovaciones pendientes por cada aviso
        const avisosConRenovacion = await Promise.all(
          avisosData.map(async (aviso) => {
            try {
              const responseRenov = await fetch(
                `${process.env.REACT_APP_PUBLICACION_RENOVAR_URL}/get_renovacion_pendiente.php?id_publicacion=${aviso.id}`,
                { method: 'GET', credentials: 'include' }
              );
              const dataRenov = await responseRenov.json();
              return {
                ...aviso,
                renovacion_pendiente: dataRenov.tiene_renovacion ? dataRenov : null
              };
            } catch {
              return { ...aviso, renovacion_pendiente: null };
            }
          })
        );

        setAvisos(avisosConRenovacion);
        const proximos = avisosConRenovacion.filter(
          a => (a.estado === 'activo' || a.estado === 'pausado') && a.dias_vence_en <= 3
        );
        if (proximos.length > 0) {
          setAvisosProxVencer(proximos);
          setShowPopupVencimiento(true);
        }
      }
    } catch (error) {
      console.error('Error al cargar datos:', error);
    }
  };

  const handleAgregarSaldo = () => {
    navigate('/agregar_saldo');
  };

const handleVerPerfil = (idAviso) => {
  navigate(`/PerfilContenido?id=${idAviso}`);
};

const handleEditar = (idAviso) => {
  navigate('/editar_publicacion', { state: { idAviso } });
};

const handleEstadoEdicion = (idAviso) => {
  navigate('/estado_edicion', { state: { idAviso } });
};

const handlePausar = (idAviso) => {
  navigate('/publicacion_pausa', { state: { idAviso } });
};

  const formatDiasHoras = (horas) => {
    const d = Math.floor(horas / 24);
    const h = horas % 24;
    return `${d} días - ${h} horas`;
  };

  const handleReanudar = async (idAviso) => {
    if (!window.confirm('¿Confirmas que deseas reanudar tu publicación ahora?')) return;
    try {
      const response = await fetch(
        `${process.env.REACT_APP_GESTION_AVISOS_URL}/put_reanudarpausa.php`,
        {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id_publicacion: idAviso })
        }
      );
      const data = await response.json();
      if (!data.success) {
        alert(`❌ ${data.message}`);
        return;
      }
      alert(`✅ Publicación reanudada. Tiempo consumido: ${data.texto_consumido}`);
      cargarDatos();
    } catch (error) {
      console.error('Error al reanudar:', error);
      alert('Error al procesar. Intenta nuevamente.');
    }
  };

  const handleRenovar = (idAviso) => {
    navigate('/publicacion_renovar', { state: { idAviso } });
  };

  const filtrarAvisos = () => {
    if (tabActivo === 'todos') return avisos;
    return avisos.filter(aviso => aviso.estado === tabActivo);
  };

  const contarPorEstado = (estado) => {
    if (estado === 'todos') return avisos.length;
    return avisos.filter(aviso => aviso.estado === estado).length;
  };

  const avisosFiltrados = filtrarAvisos();

return (
    <div className="gestion-avisos-container">

      {/* POPUP VENCIMIENTO PRÓXIMO */}
      {showPopupVencimiento && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 9999,
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <div style={{
            background: 'white', borderRadius: '12px', padding: '30px',
            maxWidth: '480px', width: '90%', border: '4px solid #CC0000',
            textAlign: 'center'
          }}>
            <p style={{
              fontFamily: 'Arial Black, Arial, sans-serif', fontSize: '20px',
              color: '#CC0000', fontWeight: '900', marginBottom: '15px'
            }}>
              ⚠️ PUBLICACIÓN PRÓXIMA A VENCER
            </p>
            {avisosProxVencer.map(a => (
              <p key={a.id} style={{fontFamily: 'Arial, sans-serif', fontSize: '15px', color: '#000', marginBottom: '8px'}}>
                <strong>{a.nombre}</strong> vence en <strong>{a.dias_vence_en} día(s)</strong>.
              </p>
            ))}
            <p style={{fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333', margin: '15px 0'}}>
              Tu publicación está próxima a vencer. Renueva tu publicación o pasará a estado <strong>"Vencida"</strong>. Recuerda verificar si tienes saldo disponible a favor.
            </p>
            <button
              onClick={() => setShowPopupVencimiento(false)}
              style={{
                background: '#008000', color: 'white', border: 'none',
                padding: '12px 30px', borderRadius: '8px', cursor: 'pointer',
                fontFamily: 'Arial Black, Arial, sans-serif', fontSize: '16px', fontWeight: '900'
              }}
            >
              ENTENDIDO
            </button>
          </div>
        </div>
      )}

      {/* HEADER */}
      <div className="gestion-header">
        <h1 className="gestion-titulo">GESTIÓN - AVISOS</h1>
        
        <div className="saldo-section">
          <div className="saldo-info">
            <p className="saldo-label">Saldo disponible</p>
            <p className="saldo-monto">$ {saldoActual.toLocaleString('es-CL')}</p>
          </div>
          <button className="btn-agregar-saldo" onClick={handleAgregarSaldo}>
            + AGREGAR SALDO
          </button>
        </div>
      </div>

      {/* TEXTO INFORMATIVO */}
      <div className="info-box-blanco">
        <p className="info-texto">
          Puedes administrar tus avisos, pausarlos pero solo para el plan premium, para ver detalles de cada plan puedes seleccionar el botón "Renovar".
        </p>
        <p className="info-texto">
          Se te notificará cuando esté por finalizar el plan que contrataste para renovarlo por el mismo u otro.
        </p>
        <p className="info-texto">
          Cualquier duda puedes contactarnos vía whatsapp o Telegram.
        </p>
      </div>

      {/* TABS */}
      <div className="tabs-container">
        <button 
          className={`tab ${tabActivo === 'todos' ? 'tab-activo' : ''}`}
          onClick={() => setTabActivo('todos')}
        >
          Todos ({contarPorEstado('todos')})
        </button>
        <button 
          className={`tab ${tabActivo === 'activo' ? 'tab-activo' : ''}`}
          onClick={() => setTabActivo('activo')}
        >
          Activos ({contarPorEstado('activo')})
        </button>
        <button 
          className={`tab ${tabActivo === 'pausado' ? 'tab-activo' : ''}`}
          onClick={() => setTabActivo('pausado')}
        >
          Pausados ({contarPorEstado('pausado')})
        </button>
        <button 
          className={`tab ${tabActivo === 'vencido' ? 'tab-activo' : ''}`}
          onClick={() => setTabActivo('vencido')}
        >
          Vencidos ({contarPorEstado('vencido')})
        </button>
      </div>

      {/* AVISOS */}
      <div className="avisos-lista">
        {avisosFiltrados.map(aviso => (
          <div key={aviso.id} className={`aviso-card aviso-card-${aviso.estado}`}>
            {/* HEADER DEL CARD */}
            <div className="card-header">
              <div className={`badge-estado badge-estado-${aviso.estado}`}>
                {aviso.estado.toUpperCase()}
              </div>
              <div className={`badge-plan badge-plan-${aviso.plan}`}>
                Plan: {aviso.plan.charAt(0).toUpperCase() + aviso.plan.slice(1)}
              </div>
            </div>

            {/* BODY DEL CARD */}
            <div className="card-body">
            {/* FOTO PERFIL */}
              <div className="perfil-foto">
                {!imgErrors[aviso.id] ? (
                  <img
                    src={`${process.env.REACT_APP_UPLOADS_URL}/${aviso.foto_perfil_url}`}
                    alt="Perfil"
                    onError={() => setImgErrors(prev => ({ ...prev, [aviso.id]: true }))}
                  />
                ) : (
                  <div className="perfil-placeholder">
                    <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx="12" cy="7" r="4" />
                    </svg>
                  </div>
                )}
              </div>

{/* INFO PERFIL */}
              <div className="perfil-info">
                <h3 className="perfil-nombre">{aviso.nombre} - {aviso.edad}</h3>
                <p className="perfil-ubicacion">{aviso.ubicacion}</p>

                {/* BANNER PAUSADO */}
                {aviso.estado === 'pausado' && (
                  <div className="banner-pausado">
                    Anuncio pausado desde: {aviso.pausado_desde}
                  </div>
                )}

                {/* BANNER VENCIDO */}
                {aviso.estado === 'vencido' && (
                  <div className="banner-vencido">
                    Anuncio vencido desde: {aviso.vencido_desde}
                  </div>
                )}

                {/* BARRA DE PROGRESO (solo para activo y pausado) */}
                {(aviso.estado === 'activo' || aviso.estado === 'pausado') && (
                  <div className="progreso-container">
                    <div className="progreso-label">
                      <span>Días publicados</span>
                      <span>
                        <strong>
                          {aviso.dias_publicados} días, {aviso.horas_publicadas_resto} horas / {aviso.dias_totales} días
                        </strong>
                      </span>
                    </div>
                    <div className="progreso-barra">
                      <div
                        className={`progreso-fill progreso-fill-${aviso.estado}`}
                        style={{ width: `${aviso.dias_totales > 0 ? (aviso.horas_publicadas / (aviso.dias_totales * 24)) * 100 : 0}%` }}
                      ></div>
                    </div>
                  </div>
                )}

{/* 3 CUADROS DE INFO + cuadro reanudará en (solo pausado) */}
                <div className="info-cuadros">
<div className={`info-cuadro info-cuadro-${aviso.estado}`}>
                    <p className="cuadro-label">Vence en</p>
                    <p className="cuadro-valor">{aviso.dias_vence_en} días - {aviso.horas_vence_en} horas - {aviso.mins_vence_en} min</p>
                  </div>
{aviso.estado !== 'vencido' && (
                  <div className={`info-cuadro info-cuadro-${aviso.estado}`}>
                    <p className="cuadro-label">Pausas usadas</p>
                    {aviso.horas_pausa_maximas > 0 ? (
                      <>
                        <p className="cuadro-valor">
                          {aviso.horas_pausa_consumidas}h {aviso.mins_pausa_consumidos}min usadas | Disponibles: {aviso.horas_pausa_disponibles}h {aviso.mins_pausa_disponibles}min (quedan)
                        </p>
                        <p style={{ fontSize: '12px', color: '#CC0000', marginTop: '4px', fontStyle: 'italic', fontWeight: 'bold' }}>
                          Informativo: Total del plan asignado: {aviso.horas_pausa_maximas} horas
                        </p>
                      </>
                    ) : (
                      <p className="cuadro-valor" style={{ color: '#CC0000', fontWeight: 'bold' }}>
                        Plan adquirido NO contempla pausas
                      </p>
                    )}
                  </div>
                  )}
                  <div className={`info-cuadro info-cuadro-${aviso.estado}`}>
                    <p className="cuadro-label">Fecha vencimiento</p>
                    <p className="cuadro-valor">{aviso.fecha_vencimiento}</p>
                  </div>
{aviso.estado === 'pausado' && aviso.reanuda_en && (
                    <div className="info-cuadro info-cuadro-pausado">
                      <p className="cuadro-label">Publicación se reanudará en</p>
                      <p className="cuadro-valor">{aviso.reanuda_en}</p>
                    </div>
                  )}
                  <div className={`info-cuadro info-cuadro-${aviso.estado}`}>
                    <p className="cuadro-label">Próxima renovación</p>
                    {aviso.renovacion_pendiente ? (
                      <p className="cuadro-valor" style={{ color: '#008000', fontWeight: 'bold' }}>
                        {aviso.renovacion_pendiente.fecha_programada}<br/>
                        <span style={{ fontSize: '12px', fontWeight: 'normal' }}>
                          Plan: {aviso.renovacion_pendiente.plan_nombre}
                        </span>
                      </p>
                    ) : (
                      <p className="cuadro-valor" style={{ color: '#999', fontStyle: 'italic' }}>
                        Sin renovaciones pendientes
                      </p>
                    )}
                  </div>
                </div>

                {/* BOTONES DE ACCIÓN */}
                <div className="card-acciones">
{aviso.estado === 'activo' && (
  <>
    <button 
      className="btn-accion btn-editar"
      onClick={() => handleEditar(aviso.id)}
    >
      EDITAR
    </button>
    <button 
      className="btn-accion btn-estado-edicion"
      onClick={() => handleEstadoEdicion(aviso.id)}
    >
      ESTADO EDICION
    </button>
    <button 
      className="btn-accion btn-ver-perfil"
      onClick={() => handleVerPerfil(aviso.id)}
    >
      VER PERFIL
    </button>
{aviso.horas_pausa_maximas > 0 ? (
      <button 
        className="btn-accion btn-pausar"
        onClick={() => handlePausar(aviso.id)}
      >
        PAUSAR
      </button>
    ) : (
      <button 
        className="btn-accion btn-pausar"
        style={{ backgroundColor: '#aaa', cursor: 'not-allowed' }}
        onClick={() => alert('Plan NO habilitado para pausas.')}
      >
        PAUSAR
      </button>
    )}
    <button 
      className="btn-accion btn-renovar"
      onClick={() => handleRenovar(aviso.id)}
    >
      RENOVAR
    </button>
  </>
)}

                  {aviso.estado === 'pausado' && (
                    <>
                      <button 
                        className="btn-accion btn-reanudar"
                        onClick={() => handleReanudar(aviso.id)}
                      >
                        REANUDAR AHORA
                      </button>
                      <button 
                        className="btn-accion btn-ver-perfil"
                        onClick={() => handleVerPerfil(aviso.id)}
                      >
                        VER PERFIL
                      </button>
                    </>
                  )}

{aviso.estado === 'vencido' && (
                    <>
                      <button 
                        className="btn-accion btn-renovar"
                        onClick={() => navigate('/saldo_ordencompra')}
                      >
                        RENOVAR PUBLICACIÓN
                      </button>
                      <button 
                        className="btn-accion btn-ver-perfil"
                        onClick={() => handleVerPerfil(aviso.id)}
                      >
                        VER PERFIL
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
</div>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="https://www.youtube.com/@ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
      </footer>
    </div>
  );
};

export default GestionAvisos;
